// extracted by mini-css-extract-plugin
export var cardHeader = "_fw-0";
export var reorderHandle = "_fw-3";
export var titleArea = "_fw-1";
export var titleAreaWithHandle = "_fw-2";